<div *commonUiOptionalWizardStep>
  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.TITEL' | translate }}</h2>
    <common-ui-lohnsteuer [(data)]="data" [readonly]="readonly"></common-ui-lohnsteuer>
  </div>
</div>
